import { Card, Empty, Typography } from "antd";
import { Column } from "@ant-design/plots";
import { useQuery } from "@apollo/client";

import { ENDPOINT_RPC_ORIGIN_METRICS_QUERY } from "../../helpers/graphql/endpoint";

export function EndpointOriginMetrics({
  project,
  network,
  chain,
  archive,
  interval,
  showLast,
  height,
}: any) {
  const { loading, data } = useQuery(ENDPOINT_RPC_ORIGIN_METRICS_QUERY, {
    variables: { projectId: project.id, network: network, chain, archive, interval, showLast },
  });

  const endpointMetricsByOrigin =
    data?.endpointMetricsByOrigin.length > 0
      ? data?.endpointMetricsByOrigin
      : [
          {
            data: [],
            group: null,
          },
        ];

  let flattenArray: { group: string; timestamp: String; count: Number }[] = [];
  endpointMetricsByOrigin.map((item: any) => {
    return item.data.map((point: any) => {
      return flattenArray.push({
        group: item.group,
        timestamp: new Date(point.timestamp)
          .toISOString()
          .replace("T", " ")
          .split(".")[0]
          .slice(0, -3),
        count: point.count,
      });
    });
  });

  flattenArray = flattenArray.sort((a: any, b: any) => a.timestamp.localeCompare(b.timestamp));

  const config = {
    data: flattenArray,
    isStack: true,
    xField: "timestamp",
    xAxis: {
      tickCount: 25,
      label: {
        formatter: (v: string) => v.split(" ")[1],
      },
    },
    yField: "count",
    yAxis: {
      maxLimit: flattenArray.length > 0 ? null : 4,
    },
    seriesField: "group",
    tooltip: {
      formatter: ({ group, count }: any) => {
        return {
          name: group,
          value: Intl.NumberFormat("en-US", {
            notation: "compact",
            maximumFractionDigits: 1,
          }).format(count),
        };
      },
    },
  };

  return loading ? (
    <Card loading={true} className="card-loading" />
  ) : (
    <Card className={"card-body"} title="Request by origin">
      <Typography.Text style={{ color: "grey" }}></Typography.Text>
      {endpointMetricsByOrigin ? <Column {...config} height={height} /> : <Empty />}
    </Card>
  );
}
